import { Skeleton, Stack } from "@mui/material";
import React from "react";

export default function PopularProductsSk() {
  return (
    <Stack sx={{  p: "1rem" }}>
      

      
      {/* Carousel Area Skeleton */}
      <Skeleton
        variant="rounded"
        height={250}
        sx={{
          width: "75%",
          mx: "auto",
          mt: 4,
          borderRadius: "1rem",
        }}
      />
    </Stack>
  );
}
